export default __webpack_public_path__ + "static/home-902619ae543fb85862e58f20a3e20c93.png";